<template>
  <!-- Pricing Plan -->
  <section class="price-section">
    <div class="container">
      <!-- Heading title-->
      <div class="section-heading heading-three mx-auto" data-aos="fade-down">
        <h2 class="mx-auto">
          Scrutinize the Optimum Pricing Scheme <span>to Begin</span>.
        </h2>
        <p>
          Pricing plans for businesses at every stage of growth. Try our risk-free for 14
          days. No credit card required.
        </p>
      </div>
      <!-- /Heading title -->

      <!-- Plan Selected -->
      <div class="price-tab">
        <ul class="nav">
          <li>
            <a
              href="javascript:;"
              data-bs-toggle="tab"
              data-bs-target="#month"
              class="active"
              >Monthly</a
            >
          </li>
          <li>
            <a href="javascript:;" data-bs-toggle="tab" data-bs-target="#year"
              >Yearly<span>Save 20%</span></a
            >
          </li>
        </ul>
      </div>
      <!-- /Plan Selected -->
      <div class="tab-content">
        <div class="tab-pane show active" id="month">
          <div class="row align-items-center justify-content-center">
            <div class="col-lg-4 col-md-6 col-12" data-aos="fade-down">
              <div class="price-wrap">
                <div class="price-head">
                  <span class="level-badge">Basic </span>
                  <p>
                    For all individuals and starters who want to start with domaining.
                  </p>
                </div>
                <div class="price-level">
                  <h3>$15</h3>
                  <p>Per member, per Month</p>
                  <span class="trial-day">Start free 14-day Trial</span>
                </div>
                <div class="price-details">
                  <ul>
                    <li><i class="bx bxs-check-circle"></i>Access to All Features</li>
                    <li><i class="bx bxs-check-circle"></i>1k lookups / per month</li>
                    <li><i class="bx bxs-check-circle"></i>10 Monitoring Quota</li>
                    <li><i class="bx bxs-check-circle"></i>30K API Credits / month</li>
                    <li>
                      <i class="bx bxs-check-circle"></i>60 minutes Monitoring intervel
                    </li>
                    <li><i class="bx bxs-check-circle"></i>20% discount on backorders</li>
                    <li>
                      <i class="bx bxs-check-circle"></i>Domain Name Appraisal
                      <span class="coming-soon">Coming Soon</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-12" data-aos="fade-down">
              <div class="price-wrap active">
                <div class="price-head">
                  <span class="level-badge bg-green">Commercial </span>
                  <p>
                    For all individuals and starters who want to start with domaining.
                  </p>
                </div>
                <div class="price-level">
                  <h3>$55</h3>
                  <p>Per member, per Month</p>
                  <span class="trial-day bg-primary">Start free 14-day Trial</span>
                </div>
                <div class="price-details">
                  <ul>
                    <li><i class="bx bxs-check-circle"></i>Access to All Features</li>
                    <li><i class="bx bxs-check-circle"></i>1k lookups / per month</li>
                    <li><i class="bx bxs-check-circle"></i>10 Monitoring Quota</li>
                    <li><i class="bx bxs-check-circle"></i>30K API Credits / month</li>
                    <li>
                      <i class="bx bxs-check-circle"></i>60 minutes Monitoring intervel
                    </li>
                    <li><i class="bx bxs-check-circle"></i>20% discount on backorders</li>
                    <li>
                      <i class="bx bxs-check-circle"></i>Domain Name Appraisal
                      <span class="coming-soon">Coming Soon</span>
                    </li>
                  </ul>
                </div>
                <div class="feature-text">
                  <span class="bg-danger">Best Value</span>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-12" data-aos="fade-down">
              <div class="price-wrap">
                <div class="price-head">
                  <span class="level-badge bg-purple">Premium </span>
                  <p>
                    For all individuals and starters who want to start with domaining.
                  </p>
                </div>
                <div class="price-level">
                  <h3>$105</h3>
                  <p>Per member, per Month</p>
                  <span class="trial-day">Start free 14-day Trial</span>
                </div>
                <div class="price-details">
                  <ul>
                    <li><i class="bx bxs-check-circle"></i>Access to All Features</li>
                    <li><i class="bx bxs-check-circle"></i>1k lookups / per month</li>
                    <li><i class="bx bxs-check-circle"></i>10 Monitoring Quota</li>
                    <li><i class="bx bxs-check-circle"></i>30K API Credits / month</li>
                    <li>
                      <i class="bx bxs-check-circle"></i>60 minutes Monitoring intervel
                    </li>
                    <li><i class="bx bxs-check-circle"></i>20% discount on backorders</li>
                    <li><i class="bx bxs-check-circle"></i>Domain Name Appraisal</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="year">
          <div class="row align-items-center justify-content-center">
            <div class="col-lg-4 col-md-6 col-12" data-aos="fade-down">
              <div class="price-wrap">
                <div class="price-head">
                  <span class="level-badge">Basic </span>
                  <p>
                    For all individuals and starters who want to start with domaining.
                  </p>
                </div>
                <div class="price-level">
                  <h3>$55</h3>
                  <p>Per member, per Month</p>
                  <span class="trial-day">Start free 14-day Trial</span>
                </div>
                <div class="price-details">
                  <ul>
                    <li><i class="bx bxs-check-circle"></i>Access to All Features</li>
                    <li><i class="bx bxs-check-circle"></i>1k lookups / per month</li>
                    <li><i class="bx bxs-check-circle"></i>10 Monitoring Quota</li>
                    <li><i class="bx bxs-check-circle"></i>30K API Credits / month</li>
                    <li>
                      <i class="bx bxs-check-circle"></i>60 minutes Monitoring intervel
                    </li>
                    <li><i class="bx bxs-check-circle"></i>20% discount on backorders</li>
                    <li>
                      <i class="bx bxs-check-circle"></i>Domain Name Appraisal
                      <span class="coming-soon">Coming Soon</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-12" data-aos="fade-down">
              <div class="price-wrap active">
                <div class="price-head">
                  <span class="level-badge bg-green">Commercial </span>
                  <p>
                    For all individuals and starters who want to start with domaining.
                  </p>
                </div>
                <div class="price-level">
                  <h3>$85</h3>
                  <p>Per member, per Month</p>
                  <span class="trial-day bg-primary">Start free 14-day Trial</span>
                </div>
                <div class="price-details">
                  <ul>
                    <li><i class="bx bxs-check-circle"></i>Access to All Features</li>
                    <li><i class="bx bxs-check-circle"></i>1k lookups / per month</li>
                    <li><i class="bx bxs-check-circle"></i>10 Monitoring Quota</li>
                    <li><i class="bx bxs-check-circle"></i>30K API Credits / month</li>
                    <li>
                      <i class="bx bxs-check-circle"></i>60 minutes Monitoring intervel
                    </li>
                    <li><i class="bx bxs-check-circle"></i>20% discount on backorders</li>
                    <li>
                      <i class="bx bxs-check-circle"></i>Domain Name Appraisal
                      <span class="coming-soon">Coming Soon</span>
                    </li>
                  </ul>
                </div>
                <div class="feature-text">
                  <span class="bg-danger">Best Value</span>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-12" data-aos="fade-down">
              <div class="price-wrap">
                <div class="price-head">
                  <span class="level-badge bg-purple">Premium </span>
                  <p>
                    For all individuals and starters who want to start with domaining.
                  </p>
                </div>
                <div class="price-level">
                  <h3>$105</h3>
                  <p>Per member, per Month</p>
                  <span class="trial-day">Start free 14-day Trial</span>
                </div>
                <div class="price-details">
                  <ul>
                    <li><i class="bx bxs-check-circle"></i>Access to All Features</li>
                    <li><i class="bx bxs-check-circle"></i>1k lookups / per month</li>
                    <li><i class="bx bxs-check-circle"></i>10 Monitoring Quota</li>
                    <li><i class="bx bxs-check-circle"></i>30K API Credits / month</li>
                    <li>
                      <i class="bx bxs-check-circle"></i>60 minutes Monitoring intervel
                    </li>
                    <li><i class="bx bxs-check-circle"></i>20% discount on backorders</li>
                    <li><i class="bx bxs-check-circle"></i>Domain Name Appraisal</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="price-bg">
        <img class="img-fluid shape-01" src="@/assets/img/bg/price-bg.png" alt="Image" />
        <img
          src="@/assets/img/bg/destination-bg-01.png"
          class="img-fluid shape-02"
          alt="img"
        />
        <img src="@/assets/img/bg/price-bg-01.png" class="img-fluid shape-03" alt="img" />
      </div>
    </div>
  </section>
  <!-- /Pricing Plan -->
</template>
